import { SizeGuideV2 } from './SizeGuideV2'

export { SizeGuideV2 }
